<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div>
              Choose a frequency from the dropdown and select whether or not you want to receive an email when
              this notification is generated. <em>Please note that no email will be sent unless a frequency other than 'Never' is selected.</em><br />
              When finished, please click Save below to save your selections
            </div>
            <div v-if="loaded===true" class="mt-4">
              <div class="row notiheader">
                <div class="col-4">Notification</div>
                <div class="col-4">Frequency</div>
                <div class="col-2 text-center">Duplicate to Email</div>
                <div class="col-2 text-center">Email Only</div>
              </div>
              <div v-for="nrow in notifications" class="mb-3 row">
                <div class="col-4">
                  {{nrow.name}}
                </div>
                <div class="col-4">
                  <select class="w50" v-model="nrow.freq">
                    <option value="-1">Never</option>
                    <option value="0">Immediately</option>
                    <option value="1">Daily (4:05 AM (UTC-5) Every Day)</option>
                    <option value="2">Weekly (4:05 AM (UTC-5) Every Monday)</option>
                    <option value="3">Monthly (4:05 AM (UTC-5) Every First Day of Month)</option>
                    <option value="4">Quarterly (4:05 AM (UTC-5) Jan 1, Apr 1, Jul 1, Oct 1)</option>
                    <option value="5">Semi-Annually (4:05 AM (UTC-5) Jan 1, Jul 1)</option>
                    <option value="6">Annually (4:05 AM (UTC-5) Jan 1)</option>
                  </select>
                </div>
                <div class="col-2 text-center">
                  <input type="checkbox" class="checkbox" v-model="nrow.eml">
                </div>
                <div class="col-2 text-center">
                  <input type="checkbox" class="checkbox" v-model="nrow.onl">
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 text-right">
                  <button class="btn btn-primary btn-short" @click="doSave">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>

  </div>
</template>

<style scoped>
   .notiheader div {
       font-weight:600;
   }
</style>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"

  export default {
    name: 'CliNotifications',
    components:{acheader,acfooter,clientsidebar},
    data() {
      return {
        notifications:null,
        loaded:false
      }
    },
    methods: {
      doSave() {
        var commands = [];

        for (var y = 0; y < this.notifications.length; y++) {
          if (this.notifications[y].cln !== null) {
            commands.push({
              Operation: "Client",
              Function: "DeleteNotification",
              Fields: {
                ClientNotificationID: this.notifications[y].cln
              }
            })
          } 
        }

        if (commands.length > 0) {
          this.apiCommand(commands).then(r=>{

            commands = [];
            for (var y = 0; y < this.notifications.length; y++) {
              if (this.notifications[y].freq > -1) {
                commands.push({
                  Operation: "Client",
                  Function: "AddNotification",
                  Fields: {
                    NotificationID: this.notifications[y].id,
                    Frequency: this.notifications[y].freq,
                    ShouldEmail: this.notifications[y].eml? "true" : "false",
                    OnlyEmail: this.notifications[y].onl ? "true" : "false"
                  }
                })
              }
            }

            if (commands.length > 0) {
              this.apiCommand(commands).then(r=>{
                this.popDialog(0,"Notification Choices Saved");
                this.renderNotifications();
              });
            }
            else {
              this.popDialog(0,"Notification Choices Saved");
              this.renderNotifications();
            }

          });
        }
        else {

          commands = [];
          for (var y = 0; y < this.notifications.length; y++) {
            if (this.notifications[y].freq > -1) {
              commands.push({
                Operation: "Client",
                Function: "AddNotification",
                Fields: {
                  NotificationID: this.notifications[y].id,
                  Frequency: this.notifications[y].freq,
                  ShouldEmail: this.notifications[y].eml? "true" : "false",
                  OnlyEmail: this.notifications[y].onl ? "true" : "false"
                }
              })
            }
          }

          if (commands.length > 0) {
            this.apiCommand(commands).then(r=>{
           
              this.popDialog(0,"Notification Choices Saved");
              this.renderNotifications();

            });
          }
          else {
            this.popDialog(1,"No changes were made");
          }

        }

      },
      renderNotifications() {
        this.apiCommand([{
          Operation: "Client",
          Function: "GetNotifications",
          Fields: {}
        }]).then(response=> {

          var cr = JSON.parse(response.CommandResult);
          var noti = JSON.parse(cr.returnObjects[0].returnObject);

          this.notifications = [
              { id: "61258d2e-e22c-4179-ac1b-6a0b78fca316", name: "Member Verifies Account", freq:-1, eml: false, cln: null, onl:false },
              { id: "e81911b9-0123-4473-a0e7-9a664db92b4e", name: "Member Fails to Log In More Than 3 Times", freq: -1, eml: false, cln: null, onl:false },
              { id: "36bb210a-fc59-4496-86ad-505f74c2521a", name: "Member Resets Password", freq: -1, eml: false, cln: null, onl:false },
              { id: "2aaca9fc-0468-4fd4-9831-e1cb7e8169ba", name: "Member Completes Curricula", freq: -1, eml: false, cln: null, onl:false },
              { id: "943bb970-ff42-41b1-a930-ac8371789258", name: "Member Starts Curricula", freq: -1, eml: false, cln: null, onl:false },
              { id: "b591b148-3810-4687-a7bd-966f45ae6280", name: "Member Was Added via Admin Center", freq: -1, eml: false, cln: null, onl:false },
              { id: "0470351b-9835-454f-8051-85a3a7c026bb", name: "Member Was Added via Promo Code", freq: -1, eml: false, cln: null, onl:false },
              { id: "d123704d-7f80-4bc0-a259-84ac07edf026", name: "Member Was Removed From Pool", freq: -1, eml: false, cln: null, onl:false },
              { id: "71e86282-7947-4f32-bccb-99a9c02477ca", name: "Member Pool Privileges were Added", freq: -1, eml: false, cln: null, onl:false },
              { id: "54b039d6-b57e-4e25-80d1-b59755258d75", name: "Member Pool Privileges were Revoked", freq: -1, eml: false, cln: null, onl:false },
              { id: "05cca40d-bd06-44af-b0ce-347b40336618", name: "Member Invite was Accepted", freq: -1, eml: false, cln: null, onl:false }
          ]

          for (var x = 0; x < noti.length; x++) {
            for (var y = 0; y < this.notifications.length; y++) {
              if (noti[x].NotificationID == this.notifications[y].id) {
                this.notifications[y].freq = noti[x].Frequency;
                this.notifications[y].eml = noti[x].ShouldEmail;
                this.notifications[y].onl = noti[x].OnlyEmail;
                this.notifications[y].cln = noti[x].ClientNotificationID;
              }
            }
          }

          this.bootstrapClient(this.$route.params.id);
          this.loaded=true;
         
        });
      }
    },
    mounted() {
      this.doPage().then(r=>{

        this.renderNotifications();
      });
    }
  }
</script>
